const popoverController = require('frontend-controller/lib/controllers/popover');

module.exports = {
    events: {
        show: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();
                const self = event.data.component;
                const $target = $(event.target).closest('button');
                const fieldType = $target.data('fieldType')

                if(fieldType === 'selectAlternativeTab'){
                    self.showSelection($target)
                }
            }
        },
    },

    methods: {
        showSelection($button){
            return this.performAndStoreAction(
                'showAlternativeTabSelection_inEffect',
                this.prepareAction(popoverController.getPopoverAction($button, 'button'), undefined, undefined, {
                    source: {
                        container: {
                            componentData: {
                                config: {
                                    orientation: 'SE-NE',
                                    autoOpen: true,
                                    distance: {
                                        // y: '10px'
                                    }
                                },
                                methods: {
                                    onShow(){
                                        this.triggerFind('onShow')
                                    },
                                }
                            }
                        },
                        content: {
                            componentData: {
                                component: [
                                    'templates',
                                    'core',
                                    'tabStrip',
                                    'alternativeTabList',
                                ],
                                model: {
                                    config: {}
                                },
                            }
                        }
                    }
                })
            )
        }
    }
}